declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export default function sendGTMEvent({
  event,
  ...rest
}: { event: string } & Record<string, string>) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...rest });
}
